import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
// import red from '@material-ui/core/colors/red';
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

const breakpoints = createBreakpoints({});

export const theme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      primary: {
        main: "#006099",
      },
      secondary: {
        main: "#188299",
      },
    },
    typography: {
      fontFamily: [
        // 'Noto Sans',
        '"Noto Sans"',
      ].join(","),
    },
    overrides: {
      MuiTab: {
        // Name of the rule
        root: {
          [breakpoints.up("sm")]: {
            minWidth: "100px",
          },
        },
      },
    },
  })
);
